import React, { useState } from 'react';
import { db } from '../firebase'; 
import { doc, setDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { setCookie } from '../utils/cookies';

const Home: React.FC = () => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const navigate = useNavigate();

  // Handle phone input: only digits, max 10
  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    
    const digits = raw.replace(/\D/g, '');
    
    const limited = digits.slice(0, 10);
    setPhone(limited);

   
    if (phoneError) setPhoneError('');
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Validate phone number length
    if (phone.length !== 10) {
      setPhoneError('Phone number must be exactly 10 digits.');
      return;
    }

    try {
      await setDoc(doc(db, 'users', phone), {
        name,
        phone,
        createdAt: new Date(),
      }, { merge: true });

      setCookie('playerName', name);
      setCookie('playerPhone', phone);
      setCookie('unlockedLevel', '1');
      setCookie('gameHearts', '3');
      navigate('/levels');
    } catch (error) {
      console.error('Error saving:', error);
      alert(' Failed to save. Check console.');
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-purple-600 via-blue-500 to-indigo-600 p-4">
      
      {/* Logo */}
      <div className="flex justify-center mb-6">
            <img 
                src="/images/logo.png"   
                alt="Amaze Go Logo" 
                className="w-24 h-24 md:w-32 md:h-32 object-contain drop-shadow-lg rounded-2xl" 
                />
      </div>

      {/* White Card */}
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8 md:p-10 text-center transform transition-all hover:scale-[1.01]">
        
        <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mt-2">
          Welcome
        </h1>
        <p className="text-gray-500 mt-2 mb-6 text-sm md:text-base">
          Please enter your contact details below
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col gap-5 text-left">
          
          {/* Name Input */}
          <div>
            <label className="text-sm font-semibold text-gray-700 block mb-1.5">
              Full Name
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="John Doe"
              className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-gray-50 text-gray-800 placeholder-gray-400 focus:bg-white focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all duration-200 outline-none"
              required
            />
          </div>

          {/* Phone Input */}
          <div>
            <label className="text-sm font-semibold text-gray-700 block mb-1.5">
              Phone Number <span className="text-xs font-normal text-gray-400">(10 digits)</span>
            </label>
            <input
              type="text"  // Using text to have full control
              inputMode="numeric"
              value={phone}
              onChange={handlePhoneChange}
              placeholder="1234567890"
              className={`w-full px-4 py-3 rounded-xl border ${
                phoneError ? 'border-red-500' : 'border-gray-200'
              } bg-gray-50 text-gray-800 placeholder-gray-400 focus:bg-white focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all duration-200 outline-none`}
              required
            />
            {phoneError && (
              <p className="text-red-500 text-xs mt-1 text-left">{phoneError}</p>
            )}
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full py-3.5 mt-2 bg-gradient-to-r from-purple-600 to-blue-500 text-white font-semibold rounded-xl shadow-md hover:shadow-lg hover:scale-[1.02] transform transition-all duration-200 text-lg"
          >
            Get Started !
          </button>
        </form>

        <p className="text-xs text-gray-400 mt-6">
          We respect your privacy. Data is secure.
        </p>
      </div>
    </div>
  );
};

export default Home;